import { useRuntimeConfig } from "#imports";
import { Hanko } from "@teamhanko/hanko-elements";
export function useHanko() {
  if (process.server) {
    return null;
  }
  const hankoConfig = useRuntimeConfig().public.hanko;
  const hankoOptions = {
    cookieName: hankoConfig.cookieName,
    localStorageKey: hankoConfig.cookieName
  };
  return new Hanko(hankoConfig.apiURL, hankoOptions);
}
